const overview = {
	add: "VPS erstellen",
	empty_list: {
		title: "Sie haben noch keine VPS",
	},
	notifications: {
		create:
			"Ihr VPS <strong>{{name}}</strong> wird erstellt. Es kann eine Weile dauern, bis es sichtbar ist.",
		delete:
			"Ihr VPS <strong>{{name}}</strong> wurde erfolgreich gelöscht. Es kann eine Weile dauern, bis dies sichtbar ist.",
		network_already_existing:
			"Das private Netzwerk <strong>{{name}}</strong> kann nicht erstellt werden. Dieser Name ist bereits in Verwendung.",
		no_network:
			"Ihr VPS hat keine öffentlichen oder privaten Netzwerke konfiguriert. Fügen Sie mindestens eines davon hinzu.",
	},
	search_input: "VPS suchen",
	service_unavailable: {
		button: "Seite neu laden",
		description: "Bitte versuchen Sie es später erneut.",
		title: "Der Dienst ist derzeit nicht verfügbar.",
	},
	title: "VPS übersicht",
};

export default overview;
